import React, { useState, useEffect, useRef, useCallback, useContext } from 'react';
import Sortable from 'sortablejs';
import WorkspaceRegion from './WorkSpaceRegion';
import { useAddWorkSpaceMutation, useSortOrderMutation } from '../../Redux/Home/HomeWorkspaceSlice'
import { HomeWorkspaceTiles, AddOneWorkspace } from '../../Types/HomePageInterface'
import Dialog from '../../GenericComponents/dialog'
import { useNavigate } from 'react-router-dom';
import DetailedTooltip from '../../GenericComponents/Tooltip/DetailedTooltip'
import { HomeContext } from './Home'

import { getBaseUrl } from '../../Utils';
import DetachWorkspaceDialog from './WorkspaceDialogs/DetachWorkspace';
import DeleteWorkspaceDialog from './WorkspaceDialogs/DeleteWorkspace';
import ShareWorkspaceDialog from './WorkspaceDialogs/ShareWorkspace';
import EditWorkspaceDialog from './WorkspaceDialogs/EditWorkspace'
import { useSelector } from 'react-redux';
import { getCurrentUserData, RootState } from '../../Redux/store';
import ShareDashboardComponent from '../Workspace/shareDashboardComponenet';
import { FoundationsGenericToaster } from '../../GenericComponents/FoundationsGenericToaster';
import NoWorkspacesMessage from './NoWorkspace';
import AddWorkspaceDialog from './WorkspaceDialogs/AddNewWorkspaceDialog';
import { createWorkspaceStore, useWorkspaceStore, Zustand_WorkspaceProvider } from '../Workspace/workspaceContext';
import { WorkspaceApiDTO_Workspace } from '../../Interfaces/APIContracts/WorkspaceApiDTO_Workspace';
interface MainSectionProps { // clean up code move to interface.
  workspaces: HomeWorkspaceTiles[];
}

declare let window: any
const UnicornApp = window.unicornInstance as any

export const ZustandHomePageContextWrapper = (props: any) => {
  const store = React.useMemo(() => createWorkspaceStore(), []);

  return (
    <Zustand_WorkspaceProvider store={store}>
      {props.children}
    </Zustand_WorkspaceProvider>
  );
};


const MainSection: React.FC<MainSectionProps> = ({ workspaces }) => {

  const context = useContext(HomeContext);
  const {
    DetachThisWorkspaceDialog,
    setDetachThisWorkspaceDialog,
    EditThisWorkspaceDialog,
    setEditThisWorkspaceDialog,
    ShareThisWorkspaceDialog,
    setShareThisWorkspaceDialog,
    DeleteThisWorkspaceDialog,
    setDeleteThisWorkspaceDialog,
    WorkspaceIdforDialog,
    setWorkspaceIdforDialog,
    DialogMsg,
    setDialogMsg,
    WorkSpaceDetails,
    SetWorkSpaceDetails,
    currentUsersData,
    editCallback,
    SeteditCallback
  } = context || {}; // Safeguard if context is null


  const [AddNewWorkspaceData] = useAddWorkSpaceMutation()
  const [WorkspaceName, setWorkspaceName] = useState<string>("")
  const [WorkspaceDescription, setWorkspaceDescription] = useState(String)
  const [WorkspacePrivacy, setWorkspacePrivacy] = useState(Number)
  const [AddWorkspaceError, setAddWorkspaceError] = useState(String)

  const [showAll, setShowAll] = useState(false);
  const [sortedWorkspaces, setSortedWorkspaces] = useState<HomeWorkspaceTiles[]>(workspaces);
  const dashboardRef = useRef<HTMLDivElement>(null);
  const [showDialog, setShowDialog] = useState(false); // state to control dialog visibility
  const [isDialogOpen, setIsDialogOpen] = useState(false) // changes 

  const openDialog = () => setIsDialogOpen(true); // Open dialog
  const closeDialog = () => setIsDialogOpen(false); // Close dialog
  const [sortOrder, { isLoading: isSorting }] = useSortOrderMutation();
  const baseUrl = `${getBaseUrl()}ux/index.html#workspace/`;
  const currentUserData = useSelector(
    (state: RootState) => getCurrentUserData(state)
  )
  const isAdmin = ['FoundationsSystemAdmin', 'SystemAdmin'].indexOf(currentUserData.type) > -1
  let hasAddWorkspacePrivilege = currentUserData.privileges?.includes('Workspace_Add') || isAdmin
  const [isDragging, setIsDragging] = useState(false);

  try {
    const privileges = currentUserData?.privileges;
    // If privileges is an array
    if (Array.isArray(privileges) && privileges.includes('Workspace_Add')) {
      hasAddWorkspacePrivilege = true;
    } else if (typeof privileges === 'string' && privileges === 'Workspace_Add') {
      // If privileges is a string
      hasAddWorkspacePrivilege = true;
    } else {
      hasAddWorkspacePrivilege = false;      // FP-11776 setting hasAddWorkspacePrivilege value to false if the privileges is not an array or does not include 'Workspace_Add'
    }
  } catch (error) {
    console.error("Error fetching user privileges", error);
    hasAddWorkspacePrivilege = false;        // FP-11776 setting hasAddWorkspacePrivilege value to false if error occurs
  }

  function openAddWorkspaceDialog() {
    setWorkspaceName(""); // Reset WorkspaceName to an empty string
    setWorkspaceDescription(""); // Reset WorkspaceDescription to an empty string
    setAddWorkspaceError(""); // clears the workspace error
    setWorkspacePrivacy(0);
    openDialog();   // added data

  }

  useEffect(() => {
    // Sync sortedWorkspaces when `workspaces` changes
    setSortedWorkspaces(workspaces);
  }, [workspaces]);

  useEffect(() => {
    if (!dashboardRef.current) return;

    const sortable = new Sortable(dashboardRef.current, {
      animation: 350, // smooth animation during dragging
      ghostClass: 'ui-sortable-placeholder',
      dragClass: 'sortable-drag',
      filter: '.disable-sort-item',
      forceFallback: true,
      onMove: (evt) => {
        setIsDragging(true);
        return !evt.related.classList.contains('disable-sort-item');
      },
      onEnd: async (evt) => {
        setIsDragging(false);
        if (evt.oldIndex === undefined || evt.newIndex === undefined) return;

        const newWorkspaces = [...sortedWorkspaces];
        const [movedItem] = newWorkspaces.splice(evt.oldIndex, 1);
        newWorkspaces.splice(evt.newIndex, 0, movedItem);

        setSortedWorkspaces(workspaces);
        try {
          await sortOrder({
            dashBoardIds: newWorkspaces.map(ws => ws.WorkspaceId)
          });
        } catch (error) {
          console.error('Sort order update failed:', error);
          setSortedWorkspaces(sortedWorkspaces); // Revert on error
        }
      }
    });
    return () => {
      sortable.destroy();
      ;
    }
  }, [sortedWorkspaces]);

  const showAllWorkspaces = useCallback(() => {
    setShowAll(true);
  }, []);

  const workspaceActions_Edit_Callback = (EditedWorkspaceData: HomeWorkspaceTiles) => {

    // Update workspace details if necessary
    SetWorkSpaceDetails((prev: any) => {
      return prev.WorkspaceId === EditedWorkspaceData.WorkspaceId
        ? { ...prev, ...EditedWorkspaceData }
        : prev;
    });

    // Call handleWorkspaceEdit to update sortedWorkspaces passing the updated data in below function
    handleWorkspaceEdit(EditedWorkspaceData);
  };

  const deleteCallBack = (workspaceId: any) => {
    const updatedWorkspaces = sortedWorkspaces.filter((workspace) => String(workspace.WorkspaceId) !== String(workspaceId.WorkspaceId))
    setSortedWorkspaces(updatedWorkspaces);
  };

  const detachCallBack = (workSpaceId: any) => {
    setDetachThisWorkspaceDialog(false) // Prajakta we need a better way to handle onClose in the detachDialog component.
    const detachedWorkspace = sortedWorkspaces.filter((workspace) => String(workspace.WorkspaceId) !== String(workSpaceId.WorkspaceId))
    setSortedWorkspaces(detachedWorkspace);
  }

  const AddWorkSpaceCallBack = (value: any) => {
    setSortedWorkspaces(value)
    setShowDialog(false);
  }

  const handleWorkspaceNameUpdate = (workspaceId: number, newName: string, description: string, privacyLock: number) => {
    setSortedWorkspaces((prev) =>
      prev.map((ws) =>
        ws.WorkspaceId === workspaceId ? { ...ws, Name: newName, Description: description, PrivacyLock: privacyLock } : ws
      )
    );
    // If using Zustand:
    // useWorkspaceStore.getState().updateWorkspace({ WorkspaceId: workspaceId, Name: newName });
  };

  const handleWorkspaceEdit = (updatedWorkspace: HomeWorkspaceTiles) => {
    setSortedWorkspaces((prevWorkspaces) => {
      const updatedList = prevWorkspaces.map((workspace) =>
        String(workspace.WorkspaceId) === String(updatedWorkspace.WorkspaceId)
          ? updatedWorkspace
          : workspace
      );
      return updatedList;
    });
  };

  let WorkSpaceCount = sortedWorkspaces.length;
  const NUMBEROFWORKSPACESTOBESHOWN: number = 12

  return (
    <ZustandHomePageContextWrapper>
      <>
        {
          workspaces.length != 0 ? (
            <div className="row mx-auto mt-4" id="main_section" style={{ position: "relative" }}>
              <div className="col-12 col-xl-12 col-lg-12 m-auto">
                <div id="content">
                  <div id="workspace_region" className="w-100">
                    <div id="dashboard_tabs_list" ref={dashboardRef} className={`row ${isDragging ? 'is-dragging' : ''}`}>
                      {sortedWorkspaces.map((workspace, index) => (
                        <WorkspaceRegion
                          HomeWorkspaceTiles={workspace}
                          isVisible={showAll || index < NUMBEROFWORKSPACESTOBESHOWN}
                          index={index} key={workspace.WorkspaceId || index}
                          currentUserData={currentUserData}
                          isDragging={isDragging}
                          onWorkspaceNameUpdate={handleWorkspaceNameUpdate} // <-- pass callback

                        />
                      )
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>)
            :
            (<NoWorkspacesMessage />)

        }

        <AddWorkspaceDialog isOpen={isDialogOpen} onClose={() => { closeDialog(); }} AddWorkSpaceCallBack={AddWorkSpaceCallBack} />

        <DetachWorkspaceDialog isOpen={DetachThisWorkspaceDialog} onClose={() => setDetachThisWorkspaceDialog(false)} WorkspaceId={WorkspaceIdforDialog} detachCallback={detachCallBack} />
        <DeleteWorkspaceDialog isOpen={DeleteThisWorkspaceDialog} onClose={() => setDeleteThisWorkspaceDialog(false)} WorkspaceId={WorkspaceIdforDialog} deleteCallback={deleteCallBack} />
        <ShareDashboardComponent
          isOpen={ShareThisWorkspaceDialog}
          dashBoardId={WorkspaceIdforDialog}
          onClose={() => setShareThisWorkspaceDialog(false)}
          onShareSuccess={() => setShareThisWorkspaceDialog(false)
          }
        >
        </ShareDashboardComponent>
        <EditWorkspaceDialog isOpen={EditThisWorkspaceDialog} onClose={() => setEditThisWorkspaceDialog(false)} DialogState={setEditThisWorkspaceDialog} />

        <div className="dashboard-tab-actions">
          {WorkSpaceCount >= 12 && (
            showAll ? (
              <span id="link_dashboard_action_count">
                <a
                  href="javascript:void(0);" // Keeping it consistent
                  className="text-basic-anchor anchor-clicked"
                  onClick={showAllWorkspaces} // Optional: To make it more consistent
                >
                  Showing all {WorkSpaceCount} workspaces
                </a>
                <span className="menu-divider">&nbsp;&bull;&nbsp;</span>
              </span>
            ) : (
              <a
                id="show_all_workspaces"
                className="text-basic-anchor text-decoration-none"
                href="javascript:void(0);"
                onClick={showAllWorkspaces}
              >
                Show all {WorkSpaceCount} workspaces
                <span className="menu-divider">&nbsp;&bull;&nbsp;</span>
              </a>
            )
          )}
          {hasAddWorkspacePrivilege && (
            <a
              href="javascript:void(0);"
              id="show_work_space_modal"
              className="text-basic-anchor"
              onClick={openAddWorkspaceDialog}
            >
              Add new workspace
            </a>
          )}
        </div>
      </>
    </ZustandHomePageContextWrapper>

  );
};

export default MainSection;


